import React, { useContext, useEffect } from 'react';
import { InputDate, Skeleton } from '@welbe/web-design-system';

import {
	Container,
	ContainerTitles,
	ContainerDates,
	OpenModal,
	ContainerCalendars,
	ContainerSkeletonDate,
	ContainerSkeletons,
} from './Header.styles';

import { ModalChangeDate } from './components/ModalChangeDate/ModalChangeDate';
import { getModalInfoByType } from './helpers/getModalInfoByType';
import { useHeader } from './Header.hooks';
import { subtitleOptions } from './Header.enum';
import { getColorMarker } from './helpers/getColorMarket';
import { ModalCommunication } from '../../../Communications/components/ModalCommunication/ModalCommunication';
import { dateScheduled } from 'utils/formatterDatesScheduled';
import { differenceInDays } from 'date-fns';
import { AlertBox } from './components/AlertBox/AlertBox';
import { CompaignFilledContext } from '../../context/CompaignFilled';
interface HeaderProps {
	campaignId: string;
	communicationOpen: boolean;
	isCommunicationsEmpty: boolean;
	onCloseComunication: () => void;
}

export const Header = ({
	campaignId,
	communicationOpen,
	isCommunicationsEmpty,
	onCloseComunication,
}: HeaderProps): JSX.Element => {
	const {
		changeDateType,
		startDateValue,
		endDateValue,
		handleToggleModal,
		isOpen,
		isLoading,
		bookDates,
		endCommunicationId,
		onRetryDates,
		startCommunicationId,
		handleCloseModal,
	} = useHeader({ campaignId });

	const modalInfoByType = getModalInfoByType(
		changeDateType || 'start',
		startDateValue,
		endDateValue,
	);

	const nowDate = new Date();
	nowDate.setHours(0, 0, 0, 0);

	const { filledCampaign, setEndedCampaign, isEndedCampaign } = useContext(
		CompaignFilledContext,
	);

	const getIsEndedCampaign = () => {
		setEndedCampaign(endDateValue ? new Date(endDateValue) < nowDate : false);
	};

	const pickerSelected: dateScheduled[] = bookDates?.map(
		(bookDate: string, index: number) => {
			const stringIndex = String(index);
			return {
				color: getColorMarker(stringIndex),
				date: bookDate,
			};
		},
	);

	const communicationCreatedTypes = [
		'introduction',
		'sensitization',
		'evaluation',
		'closing',
	];

	const reminderOption = {
		id: 'nom035-reminder',
		value: 'Recordatorio',
	};

	useEffect(() => {
		getIsEndedCampaign();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [endDateValue]);

	const hasLasThanThreeDays = endDateValue
		? differenceInDays(new Date(endDateValue), nowDate) <= 3
		: false;

	return (
		<>
			<AlertBox
				isLoading={isLoading}
				isEndedCampaign={isEndedCampaign}
				filledCampaign={filledCampaign}
				hasLasThanThreeDays={hasLasThanThreeDays}
			/>
			{!isCommunicationsEmpty && communicationOpen && (
				<ModalCommunication
					visible={communicationOpen}
					campaign={{ id: campaignId, name: '', communications: [] }}
					onClose={onCloseComunication}
					communicationCreatedDates={pickerSelected || []}
					communicationCreatedTypes={communicationCreatedTypes}
					initialCommunicationType={reminderOption}
					optionsCommunicationType={[reminderOption]}
				/>
			)}
			<ModalChangeDate
				subtitleOptions={subtitleOptions}
				onToggleModal={handleCloseModal}
				visible={isOpen}
				typeProps={modalInfoByType}
				bookDates={pickerSelected || []}
				campaignId={campaignId}
				communicationId={
					modalInfoByType.type === 'start'
						? startCommunicationId
						: endCommunicationId
				}
				onRetryDates={onRetryDates}
			/>
			<Container>
				<ContainerTitles>
					<h2>Monitoreo de la evaluación</h2>
					<h3>
						Consulta aquí el progreso de respuestas recibidas en tiempo real
					</h3>
				</ContainerTitles>
				<ContainerDates>
					{isLoading ? (
						<ContainerSkeletons>
							<ContainerSkeletonDate>
								<Skeleton height="15px" width="60%" />
								<Skeleton height="45px" />
							</ContainerSkeletonDate>
							<ContainerSkeletonDate>
								<Skeleton height="15px" width="60%" />
								<Skeleton height="45px" />
							</ContainerSkeletonDate>
						</ContainerSkeletons>
					) : (
						<ContainerCalendars>
							<OpenModal disabled>
								<InputDate
									label="Fecha de inicio"
									value={startDateValue || undefined}
									disabled={true}
								/>
							</OpenModal>
							<OpenModal
								onClick={
									endCommunicationId
										? () => handleToggleModal('end')
										: () => null
								}
								disabled={!endCommunicationId}
							>
								<InputDate
									disabled={true}
									label="Fecha de cierre"
									value={endDateValue || undefined}
								/>
							</OpenModal>
						</ContainerCalendars>
					)}
				</ContainerDates>
			</Container>
		</>
	);
};
